import React from 'react';
import { Box, IconButton, Autocomplete, TextField, Typography, Paper, Chip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const profLabels = ['Learning', 'Basic', 'Intermediate', 'Advanced', 'Expert'];

export default function SkillGroupSelector({
  mainSkillOptions = [],
  subSkillOptions = [],
  selectedMainSkill = null,
  skillProficiency = [],
  subSkills = [], // [{ subSkillId, proficiency: [] }]
  onMainSkillChange,
  onSkillProficiencyChange,
  onSubSkillsChange,
  onSubSkillProficiencyChange,
  onRemove,
  loading = false
}) {
  const selectedSubSkillIds = subSkills.map(s => s.subSkillId);
  return (
    <Paper 
      elevation={0} 
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: 3,
        width: '100%',
        background: '#ffffff',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}
    >
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography fontWeight={600} mb={0.5} color="#343a40" alignSelf="flex-start">Main Skill (Click "Add More Skills")</Typography>
        <Autocomplete
          options={mainSkillOptions}
          getOptionLabel={opt => opt.name}
          value={mainSkillOptions.find(opt => opt.id === selectedMainSkill) || null}
          onChange={(_, newValue) => onMainSkillChange(newValue ? newValue.id : null)}
          renderInput={params => <TextField {...params} variant="outlined" />}
          disabled={loading}
        />
        <Typography fontWeight={600} mb={0.5} color="#343a40" alignSelf="flex-start">Sub Skills (Choose 1 or more)</Typography>
        <Autocomplete
          multiple
          options={subSkillOptions}
          getOptionLabel={opt => opt.name}
          value={subSkillOptions.filter(opt => selectedSubSkillIds.includes(opt.id))}
          onChange={(_, newValue) => onSubSkillsChange(newValue.map(opt => opt.id))}
          renderInput={params => <TextField {...params} variant="outlined" />}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={String(option.name)}
                component="span"
                onClick={() => {}}
                onMouseDown={e => e.stopPropagation()}
                {...getTagProps({ index })}
              />
            ))
          }
          disabled={loading || !selectedMainSkill}
        />
        {subSkills.map(sub => (
          <Box key={sub.subSkillId} mt={1}>
            <Typography fontWeight={600} mb={0.5} color="#343a40" alignSelf="flex-start">
              {subSkillOptions.find(opt => opt.id === sub.subSkillId)?.name || 'Subskill'} Proficiency (optional)
            </Typography>
            <Autocomplete
              multiple
              options={[1,2,3,4,5]}
              getOptionLabel={v => `${v} = ${profLabels[v-1]}`}
              value={sub.proficiency || []}
              onChange={(_, newValue) => onSubSkillProficiencyChange(sub.subSkillId, newValue)}
              renderInput={params => <TextField {...params} variant="outlined" size="small" />}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={`${option} = ${profLabels[option-1]}`}
                    component="span"
                    onClick={() => {}}
                    onMouseDown={e => e.stopPropagation()}
                    {...getTagProps({ index })}
                  />
                ))
              }
              disabled={loading}
            />
          </Box>
        ))}
        {onRemove && (
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <IconButton onClick={onRemove} color="error">
              <DeleteIcon />
            </IconButton>
          </Box>
        )}
      </Box>
    </Paper>
  );
} 